import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  deleteUsers,
  getUserProfile,
  addNewUser,
  updateUserRole,
} from "./thunk";

interface User {
  id: number;
  name: string;
  last_name: string;
  email: string;
  is_active: boolean;
}

interface UserState {
  users: User[];
  error: string | null | {};
  loading: boolean;
}

export const initialState: UserState = {
  users: [],
  error: null,
  loading: true,
};

const usersSlice = createSlice({
  name: "usersSlice",
  initialState,
  reducers: {
    listUsers(state) {
      state.loading = true;
      state.error = null;
    },
    fetchUsersSuccess(state, action) {
      state.loading = false;
      state.users = action.payload;
    },
    fetchUsersFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // HECHOS POR MI
    builder.addCase(addNewUser.fulfilled, (state: any, action: any) => {
      state.users.unshift(action.payload);
    });
    builder.addCase(addNewUser.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(deleteUsers.fulfilled, (state: any, action: any) => {
      // const deletedUserId = action.meta.arg; // Obtiene el ID enviado
      // state.users = state.users.filter(
      //   (user: any) => user.id !== deletedUserId
      // );
    });
    builder.addCase(deleteUsers.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    // ---------------
    builder.addCase(updateUserRole.fulfilled, (state: any, action: any) => {
      state.users = state.users.map((user: any) =>
        user.id === action.payload.id ? { ...user, ...action.payload } : user
      );
    });

    builder.addCase(updateUserRole.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });

    builder.addCase(getUserProfile.fulfilled, (state: any, action: any) => {
      state.users = action.payload;
    });

    builder.addCase(getUserProfile.rejected, (state: any, action: any) => {
      state.error = action.payload ? action.payload?.error : null;
    });
  },
});

export const { listUsers, fetchUsersSuccess, fetchUsersFailure } =
  usersSlice.actions;

export default usersSlice.reducer;
